import React from "react";

const SubmitConfirmation = () => {
    return (
        <svg
            width="22"
            height="22"
            viewBox="0 0 42 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M30 15H18V12H30V15ZM18 24H30V27H18V24ZM21.0703 45L24.0703 48H0V0H36V30.0703L33 33.0703V3H3V45H21.0703ZM16.0547 10.0547L10.5 15.6094L6.44531 11.5547L8.55469 9.44531L10.5 11.3906L13.9453 7.94531L16.0547 10.0547ZM16.0547 22.0547L10.5 27.6094L6.44531 23.5547L8.55469 21.4453L10.5 23.3906L13.9453 19.9453L16.0547 22.0547ZM10.5 35.3906L13.9453 31.9453L16.0547 34.0547L10.5 39.6094L6.44531 35.5547L8.55469 33.4453L10.5 35.3906ZM41.5547 34.0547L28.5 47.1328L22.1953 40.8047L24.3047 38.6953L28.5 42.8672L39.4453 31.9453L41.5547 34.0547Z"
                fill="#0073CF"
            />
        </svg>
    );
};

export default SubmitConfirmation;
